import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'

/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import LoadingPage from '../common/LoadingPage'
import DataTable from '../common/DataTable'
import SearchInput from '../common/SearchInput/SearchInput'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import MemosIcon from '@material-ui/icons/FileCopyTwoTone'
import AddIcon from '@material-ui/icons/AddTwoTone'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Fab from '@material-ui/core/Fab'

/** Language imports **/
import { Translate, getTranslate } from 'react-localize-redux'

/** Import section actions */
import {
	loadRequirementRequestsFromBackEnd,
	getRequirementRequestsCount,
	CHANGE_REQUIREMENT_REQUESTS_SORT_CRITERIA,
	CHANGE_REQUIREMENT_REQUESTS_QUERY,
	CHANGE_REQUIREMENT_REQUESTS_PAGINATION,
} from '../../store/requirementRequest/RequirementRequestAction'
import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'

class Index extends Component {
	constructor(props) {
		super(props)
		autoBind(this)
	}

	componentDidMount() {
		if (!this.props.isLoadingUser) {
			this.props.loadRequirementRequests(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
			this.props.getRequirementRequestsCount()
		}
	}

	componentDidUpdate(prevProps) {
		let prevCompanyToken = prevProps.selectedCompany ? prevProps.selectedCompany.token : ''
		if (this.props.selectedCompany && prevCompanyToken !== this.props.selectedCompany.token) {
			this.props.loadRequirementRequests(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
			this.props.getRequirementRequestsCount()
		} else if (
			prevProps.sortCriteria.by !== this.props.sortCriteria.by ||
			prevProps.sortCriteria.ascending !== this.props.sortCriteria.ascending ||
			prevProps.searchQuery !== this.props.searchQuery ||
			prevProps.page !== this.props.page ||
			prevProps.rowsPerPage !== this.props.rowsPerPage
		) {
			this.props.loadRequirementRequests(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
		}
	}

	onChangeSortCriteria(sortBy, sortAscending) {
		this.props.changeSortCriteria(sortBy, sortAscending)
	}

	onChangeSearchValue(searchQuery) {
		this.props.changeSearchQuery(searchQuery)
	}

	getCardContent() {
		const { sortCriteria } = this.props
		if (this.props.isLoadingRequirementRequests === true) {
			return <LoadingPage />
		} else if (this.props.requirementRequests === null) {
			return (
				<div className='loader-container'>
					<Typography variant='subtitle1' gutterBottom>
						<Translate id='common.errorToGetInformation' />
					</Typography>
				</div>
			)
		} else {
			return (
				<DataTable
					data={this.props.requirementRequests}
					configuration={TableConfiguration(IsCurrentActiveDirectoryUser(this.props.user))}
					sortBy={sortCriteria.by}
					sortAscending={sortCriteria.ascending}
					onChangeSortCriteria={this.onChangeSortCriteria}
					onRowClick={(requirementRequest) => {
						this.props.history.push(`/requirementrequest/${requirementRequest.token}`)
					}}
					showFilters
					isIndex
					totalRows={this.props.requirementRequestsCount}
					page={this.props.page}
					rowsPerPage={this.props.rowsPerPage}
					onChangePage={(newPage, newRowsPerPage) => {
						this.props.changePage(newPage, newRowsPerPage)
					}}
				/>
			)
		}
	}

	getCounterMessage() {
		if (this.props.requirementRequests) {
			let totalRequests = this.props.requirementRequests.length
			return (
				<div>
					{this.props.translate('common.showing')}&nbsp;
					<span>{totalRequests}</span>&nbsp;
					{this.props.translate('common.of')}&nbsp;
					<span>{this.props.requirementRequestsCount}</span>&nbsp;
					{this.props.translate('common.records')}
				</div>
			)
		}
	}

	render() {
		const { classes } = this.props
		return (
			<Card>
				<CardHeader
					avatar={
						<Avatar>
							<MemosIcon />
						</Avatar>
					}
					action={
						<div className={classes.actionsToolbar}>
							<SearchInput
								className={classes.searchInput}
								onChangeSearchValue={this.onChangeSearchValue}
								value={this.props.searchQuery}
							/>
							{IsCurrentActiveDirectoryUser(this.props.user) && (
								<Fab
									size='small'
									color='primary'
									onClick={() => {
										this.props.history.push(`/requirementrequest/create`)
									}}
								>
									<AddIcon />
								</Fab>
							)}
						</div>
					}
					title={
						<Typography variant='button'>
							<Translate id='menu.requirementRequest' />
						</Typography>
					}
					subheader={this.getCounterMessage()}
				/>
				<CardContent>{this.getCardContent()}</CardContent>
			</Card>
		)
	}
}

function TableConfiguration(isUserInternal) {
	let columns = [
		{
			header: '',
			dataSource: 'status_indicator',
		},
		{
			header: <Translate id='common.status' />,
			dataSource: 'status_description',
			isSortable: true,
		},
		{
			header: <Translate id='common.folio' />,
			dataSource: 'folio',
			isSortable: true,
		},
		{
			header: <Translate id='common.creationDate' />,
			dataSource: 'creation_date',
			isSortable: true,
		},
		{
			header: <Translate id='memos.stage' />,
			dataSource: 'stage',
			isSortable: true,
		},
		{
			header: <Translate id='memos.developmentEngineer' />,
			dataSource: 'development_name',
			isSortable: true,
		},
	]

	if (isUserInternal) {
		columns.push({
			header: <Translate id='common.supplier' />,
			dataSource: 'supplier_name',
			isSortable: true,
		})
	}

	return { columns }
}

function mapStateToProps(state) {
	let user = state.oidc.user ? state.oidc.user : { profile: { name: '', email: '', user_type: '' } }
	let selectedCompany = state.profile.get('selectedCompany')
	return {
		user: user,
		selectedCompany: selectedCompany ? selectedCompany.toJS() : null,
		isLoadingUser: state.oidc.isLoadingUser,
		isLoadingRequirementRequests: state.requirementRequest.get('isLoadingRequirementRequests'),
		requirementRequests: state.requirementRequest.get('requirementRequests')
			? state.requirementRequest.get('requirementRequests').toJS()
			: null,
		sortCriteria: state.requirementRequest.get('sortCriteria')
			? state.requirementRequest.get('sortCriteria').toJS()
			: null,
		searchQuery: state.requirementRequest.get('searchQuery'),
		page: state.requirementRequest.get('page'),
		rowsPerPage: state.requirementRequest.get('rowsPerPage'),
		requirementRequestsCount: state.requirementRequest.get('requirementRequestsCount'),
		translate: getTranslate(state.localize),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		loadRequirementRequests: (query, orderBy, sortAscending, page, rowsPerPage) => {
			dispatch(loadRequirementRequestsFromBackEnd(query, orderBy, sortAscending, page, rowsPerPage))
		},
		changeSortCriteria: (sortBy, sortAscending) => {
			dispatch({
				type: CHANGE_REQUIREMENT_REQUESTS_SORT_CRITERIA,
				sortCriteria: {
					by: sortBy,
					ascending: sortAscending,
				},
			})
		},
		changeSearchQuery: (query) => {
			dispatch({
				type: CHANGE_REQUIREMENT_REQUESTS_QUERY,
				query: query,
			})
		},
		changePage: (page, rowsPerPage) => {
			dispatch({
				type: CHANGE_REQUIREMENT_REQUESTS_PAGINATION,
				page,
				rowsPerPage,
			})
		},
		getRequirementRequestsCount: () => {
			dispatch(getRequirementRequestsCount())
		},
	}
}

const styles = (theme) => ({
	actionsToolbar: {
		display: 'flex',
	},
	searchInput: {
		marginTop: '5px',
	},
	showingUsersCounter: {
		color: theme.palette.secondary.main,
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Index)))
)
